import React, { Component } from "react";
import { connect } from "react-redux";
import { Input, message, Divider, DatePicker } from "antd";
import moment from "moment";
import PropTypes from "prop-types";
import { getNextThursday, getNextMonday } from "../../utils/dateUtil";
import { req_add_pim_swap_log } from "../../api";
import { _uuid } from "../../utils/dataUtil";
import PicturesWall from "./pictures-wall";
import "./pictures-wall.css";
class SwapVacationZoneModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    data: PropTypes.object.isRequired,
  };
  state = {
    lock: false,
    reason: "",
    // deadline: "2026-02-07",
    deadline: "2026-09-05", // modify by s00363
    starttimeA: "0830",
    endtimeA: "1200",
    starttimeB: "0830",
    endtimeB: "1600",
    swapDateA: getNextThursday(),
    swapDateB: getNextMonday(),
    row_holiday: {
      Uid: "",
      ClockType: "FLEXIBLE",
      StaffCode: this.props.user.userCode,
      SwapDateA: "",
      SwapWorkStatusA: "WORK",
      SwapDateB: "",
      SwapWorkStatusB: "PASS",
      StartTime: "0830",
      EndTime: "1600",
      SwapReason: "平假日調換",
      ApplyStatus: "APPLY",
      RecordCreatorCode: this.props.user.userCode,
      RecordDescription: "",
      ReasonFileUrl: "",
    },
    row_work: {
      Uid: "",
      ClockType: "FLEXIBLE",
      StaffCode: this.props.user.userCode,
      SwapDateA: "",
      SwapWorkStatusA: "WORK",
      StartTimeA: "0830",
      EndTimeA: "1600",
      SwapDateB: "",
      SwapWorkStatusB: "WORK",
      StartTimeB: "0830",
      EndTimeB: "1200",
      SwapReason: "工作日調移",
      ApplyStatus: "APPLY",
      RecordCreatorCode: this.props.user.userCode,
      RecordDescription: "",
      ReasonFileUrl: "",
    },
  };

  constructor(props) {
    super(props);
    this.get_swap_images = React.createRef();
  }

  // 遠端數據處理 //////////////////////////////////////////////
  api_add_item = async (item) => {
    const { token } = this.props.user;
    const result = await req_add_pim_swap_log(item, token);
    return result.status;
  };

  // 檢核樣式 //////////////////////////////////////////////

  checkFriday = (dateString) => {
    // 檢查輸入是否為8位數字字串
    if (!/^\d{8}$/.test(dateString)) return false;

    // 解析日期字串 (yyyyMMdd)
    const year = dateString.slice(0, 4);
    const month = parseInt(dateString.slice(4, 6), 10) - 1; // 月份需減1
    const day = dateString.slice(6, 8);

    const date = new Date(year, month, day);

    // 檢查是否為有效日期
    if (isNaN(date.getTime())) return false;

    // 5: 星期五
    return date.getDay() === 5;
  };

  checkThursday = (dateString) => {
    // 檢查輸入是否為8位數字字串
    if (!/^\d{8}$/.test(dateString)) return false;

    // 解析日期字串 (yyyyMMdd)
    const year = dateString.slice(0, 4);
    const month = parseInt(dateString.slice(4, 6), 10) - 1; // 月份需減1
    const day = dateString.slice(6, 8);

    const date = new Date(year, month, day);

    // 檢查是否為有效日期
    if (isNaN(date.getTime())) return false;

    // 4: 星期四
    return date.getDay() === 4;
  };

  checkMondayToWednesday = (dateString) => {
    // 檢查輸入是否為8位數字字串
    if (!/^\d{8}$/.test(dateString)) return false;

    // 解析日期字串 (yyyyMMdd)
    const year = dateString.slice(0, 4);
    const month = parseInt(dateString.slice(4, 6), 10) - 1; // 月份需減1
    const day = dateString.slice(6, 8);

    const date = new Date(year, month, day);

    // 檢查是否為有效日期
    if (isNaN(date.getTime())) return false;

    const dayOfWeek = date.getDay();

    // 判斷是否為週一(1)至週三(3)
    return dayOfWeek >= 1 && dayOfWeek <= 3;
  };

  isBeforeSep5(input) {
    // 檢查格式
    if (!/^\d{8}$/.test(input)) return false;

    // 解析年、月、日
    const year = parseInt(input.slice(0, 4), 10);
    const month = parseInt(input.slice(4, 6), 10); // 1~12
    const day = parseInt(input.slice(6, 8), 10);

    // 建立輸入日期
    const inputDate = new Date(year, month - 1, day); // JS 月份從 0 開始

    // 建立同年度 9 月 5 日
    // const sep5 = new Date(year, 1, 7); // 1 = 2 月
    const sep5 = new Date(year, 8, 5); // 1 = 2 月 // modify by s00363

    // 檢查輸入日期是否超過 9 月 5 日
    return inputDate < sep5;
  }

  checkTime = (starttime, endtime) => {
    // 檢查輸入是否為四位數字
    if (!this.validateInput(starttime) || !this.validateInput(endtime)) {
      message.error("請輸入四位數字的時間格式，例如0800");
      return false;
    }

    // 將輸入轉換為時間格式
    const startTime = parseInt(starttime.slice(0, 2));
    const startMinute = parseInt(starttime.slice(2, 4));
    const endTime = parseInt(endtime.slice(0, 2));
    const endMinute = parseInt(endtime.slice(2, 4));

    // 檢查時間是否有效
    if (
      !this.isValidTime(startTime, startMinute) ||
      !this.isValidTime(endTime, endMinute)
    ) {
      alert("時間格式錯誤，請確保時間在00:00至23:59之間");
      return false;
    }

    // 檢查起始時間是否早於結束時間
    if (
      !this.isStartTimeBeforeEndTime(startTime, startMinute, endTime, endMinute)
    ) {
      alert("起始時間不能晚於結束時間");
      return false;
    }
    return true;
  };

  validateInput = (input) => {
    return /^\d{4}$/.test(input);
  };

  // 驗證時間是否有效
  isValidTime = (hour, minute) => {
    return hour >= 0 && hour <= 23 && minute >= 0 && minute <= 59;
  };

  // 檢查起始時間是否早於結束時間
  isStartTimeBeforeEndTime = (startHour, startMinute, endHour, endMinute) => {
    if (startHour < endHour) return true;
    if (startHour === endHour && startMinute < endMinute) return true;
    return false;
  };

  // 操作互動處理 //////////////////////////////////////////////
  handle_btn_event = (tag, item) => {
    const { reason, swapDateA, swapDateB, row_work, row_holiday } = this.state;
    switch (tag) {
      case "SwapApply":
        if (reason.length === 0) {
          message.error("請輸入調移原因");
          return;
        }
        if (swapDateA !== "" && swapDateB !== "") {
          // if (this.checkWeekend(swapDateA) && !this.checkWeekend(swapDateB)) {
          if (this.isBeforeSep5(swapDateA) && this.isBeforeSep5(swapDateB)) {
            const reasonFile = this.get_swap_images.current.output_files();
            if (typeof reasonFile[0] === "undefined") {
              message.error("尚未上傳佐證資料");
            } else {
              if (reasonFile[0].indexOf("rc-upload") !== -1) {
                message.error("資料驗證失敗，請重傳");
              } else {
                if (this.checkMondayToWednesday(swapDateB)) {
                  this.setState({ lock: true });
                  if (this.checkFriday(swapDateA)) {
                    // 平假日調換
                    row_holiday.Uid = _uuid();
                    row_holiday.ReasonFileUrl = reasonFile[0];
                    row_holiday.SwapDateA = swapDateA;
                    row_holiday.SwapDateB = swapDateB;
                    row_holiday.RecordDescription = reason;
                    this.api_add_item(row_holiday).then((result) => {
                      if (result === "success") {
                        message.success("申請平假日調換成功");
                        this.setState({ lock: true });
                      } else {
                        message.error("申請平假日調換失敗");
                        this.setState({ lock: false });
                      }
                    });
                  } else if (this.checkThursday(swapDateA)) {
                    // 工作日調移
                    row_work.Uid = _uuid();
                    row_work.ReasonFileUrl = reasonFile[0];
                    row_work.SwapDateA = swapDateA;
                    row_work.SwapDateB = swapDateB;
                    row_work.RecordDescription = reason;
                    this.api_add_item(row_work).then((result) => {
                      if (result === "success") {
                        message.success("申請工作日調移成功");
                        this.setState({ lock: true });
                      } else {
                        message.error("申請工作日調移失敗");
                        this.setState({ lock: false });
                      }
                    });
                  } else {
                    message.error("請輸入正確的週四至週五日期");
                    this.setState({ lock: false });
                  }
                } else {
                  message.error("請輸入正確的週一至週三日期");
                  this.setState({ lock: false });
                }
              }
            }
          } else {
            // message.error("日期不能超過2月7日");
            message.error("日期不能超過9月5日"); // modify by s00363
          }
        } else {
          message.error("請輸入正確日期");
        }

        break;
      default:
    }
  };

  onDateAChange = (date, dateString) => {
    this.setState({ swapDateA: dateString });
  };

  disabledDateA = (current) => {
    const { deadline } = this.state;
    // 1. 只允許選擇星期四 (4) 和星期五 (5)
    const day = current.day(); // 0=Sunday, 4=Thursday, 5=Friday
    // 2. 不能選擇 2026-02-7 之後的日期
    const lastDate = moment(deadline, "YYYY-MM-DD").endOf("day");
    return !(day === 4 || day === 5) || current.isAfter(lastDate);
  };

  onDateBChange = (date, dateString) => {
    this.setState({ swapDateB: dateString });
  };

  disabledDateB = (current) => {
    const { deadline } = this.state;
    // 取得星期幾 (0=星期日, 1=星期一, 2=星期二, 3=星期三)
    const day = current.day();
    // 設定最後可選日期為 2026-02-07
    const lastDate = moment(deadline, "YYYY-MM-DD").endOf("day");
    // 禁用非周一至周三，或超過最後日期的日期
    return !(day >= 1 && day <= 3) || current.isAfter(lastDate);
  };

  render() {
    const dateFormat = "YYYYMMDD";
    const ReasonFileUrl = [];
    const fileUrlPath = "/api/UploadFile/AddInsideMediaFile";
    const { data } = this.props;
    const { reason, lock, swapDateA, swapDateB } = this.state;
    return (
      <>
        <Divider
          orientation="left"
          size="small"
          style={{ borderColor: "#7cb305" }}
          plain
        >
          <i className="fas fa-calendar-day"></i> 周四/周五 日期
        </Divider>
        <DatePicker
          onChange={this.onDateAChange}
          format={dateFormat}
          placeholder="請輸入周四(或周五)日期"
          style={{ width: "100%" }}
          value={swapDateA ? moment(swapDateA, dateFormat) : null}
          disabledDate={this.disabledDateA}
        />
        {/* <Input
          addonBefore="日期"
          placeholder="請輸入周四(或周五)日期"
          value={swapDateA}
          onChange={(e) => this.setState({ swapDateA: e.target.value })}
        ></Input> */}
        <Divider variant="dashed" size="small">
          與
        </Divider>
        <Divider
          orientation="left"
          size="small"
          style={{ borderColor: "#7cb305" }}
          plain
        >
          <i className="fas fa-calendar-day"></i> 周一/周二/周三 日期
        </Divider>
        <DatePicker
          onChange={this.onDateBChange}
          format={dateFormat}
          placeholder="請輸入周一至周三日期"
          style={{ width: "100%" }}
          value={swapDateB ? moment(swapDateB, dateFormat) : null}
          disabledDate={this.disabledDateB}
        />
        {/* <Input
          addonBefore="日期"
          placeholder="請輸入周一至周三日期"
          value={swapDateB}
          onChange={(e) => this.setState({ swapDateB: e.target.value })}
        ></Input> */}
        <Divider variant="dashed" size="small" style={{ height: "18px" }}>
          作息互調移
        </Divider>
        <Input
          placeholder="請輸入調移原由"
          value={reason}
          onChange={(e) => this.setState({ reason: e.target.value })}
        ></Input>
        <PicturesWall
          ref={this.get_swap_images}
          images_source={ReasonFileUrl}
          api_url={fileUrlPath}
          self_filename="原由佐證圖檔"
        ></PicturesWall>
        <button
          className="btn btn-info btn-sm"
          style={{ width: "100%" }}
          onClick={() => this.handle_btn_event("SwapApply", data)}
          disabled={lock}
        >
          <i class="fas fa-user-clock" style={{ marginRight: "5px" }}></i>{" "}
          申請調移
        </button>
      </>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(SwapVacationZoneModal);
